<template lang="pug">
  main.publications(v-if="settings")
    header.header
      main-menu
    section.section
      div.container
        div.intro
         h1 {{ settings.sections.publications.title }}
         div(v-html="settings.sections.publications.subtitle")
         div.notice(v-html="settings.sections.publications.notice")
        div.filters(:class="{open: filtersOpen}")
          p.is-hidden-tablet(@click="openFilters") Filter By
            span(v-if="filtersOpen") -
            span(v-else) +
          div.wrapper
            div.year
              label year
              v-select(
                :value.sync="yearsAll"
                v-model="yearsAll"
                :options="years",
                :on-change="yearFilter"
                :searchable="true"
              )
            div.year
              label type
              v-select(
                :value.sync="yearsAll"
                v-model="yearsAll"
                :options="type",
                :on-change="typeFilter"
                :searchable="true"
              )
            div.author
              label author
              input(v-model="filters.author" class="form-text" @input="authorFilter")
            div.title
              label title
              input(v-model="filters.title" class="form-text" @input="titleFilter")
            form.actions
              button(type="button" @click="resetFilters") Reset
      div
        div.container.pubications
          div.row-item(v-for="publication in publications" :key="publication.id_report" :class="`type-${publication.id_type_pub}`")
            div(v-if="publication.url")
              a(:href="publication.url" target="new") {{ publication.titolo }}
            div(v-else) {{ publication.titolo }}
            div.author {{ publication.autori }}
            div.meta
              span.date {{ publication.data_pub }}
              span.fonte(v-if="publication.fonte")  - {{ publication.fonte }}
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import VueSelect from 'vue-select'
export default {
  name: 'publications',
  metaInfo: {
    title: 'Publications'
  },
  components: {
    'main-menu': MainMenu,
    'v-select': VueSelect
  },
  computed: {
    settings () {
      return this.$store.state.settings
    },
    publications () {
      return this.$store.getters.publications
    },
    years () {
      const year = []
      this.$store.getters.publicationsFilters.forEach(y => {
        if (!year.includes(y.year) && y.year !== null) {
          year.push(y.year)
        }
      })
      return year
    },
    type () {
      const type = []
      this.$store.getters.publicationsFilters.forEach(p => {
        if (!type.includes(p.tipo)) {
          type.push(p.tipo)
        }
      })
      return type
    }
  },
  data () {
    return {
      yearsAll: {value: null, id: null, label: 'All'},
      filtersOpen: false,
      filters: {
        type: null,
        year: null,
        author: null,
        title: null
      }
    }
  },
  methods: {
    openFilters () {
      this.filtersOpen = !this.filtersOpen
    },
    yearFilter (year) {
      if (typeof year === 'string') {
        this.filters.year = year
        this.updatePub()
      }
    },
    typeFilter (type) {
      if (typeof type === 'string') {
        this.filters.type = type
        this.updatePub()
      }
    },
    authorFilter () {
      if (typeof this.filters.author === 'string') {
        this.updatePub()
      }
    },
    titleFilter () {
      if (typeof this.filters.title === 'string') {
        this.updatePub()
      }
    },
    updatePub () {
      this.$store.commit('SET_PUB_FILTERS', {
        type: this.filters.type,
        year: this.filters.year,
        author: this.filters.author,
        title: this.filters.title
      })
    },
    resetFilters () {
      this.filters.year = null
      this.filters.author = null
      this.filters.title = null
      this.filters.type = null
      this.yearsAll = {value: null, id: null, label: 'All'}
      this.updatePub()
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_PUBLICATIONS_LIST')
  },
  beforeDestroy () {
    this.filtersOpen = false
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

a {
  color: #5477a3;
}

.header {
  background-image: url('../assets/news-header.jpg');
}
.publications .section > div:nth-child(2) .pubications {
  padding-top: 390px;
  padding-bottom: 200px;
}

.container.pubications {
  background-color: #ffffff;
  .row-item {
    position: relative;
    padding: 2em 4em 0 10em;
    &::before {
      content: '';
      background-image: url("../assets/sprites-2X.png");
      width: 45px;
      height: 45px;
      position: absolute;
      margin-left: -4em;
      margin-top: .3em;
      background-size: 478px 442px;
      background-position: 0px -269px;
    }
    &.type-1::before {
      background-position: 0px -269px;
    }
    &.type-2::before {
      background-position: -45px -269px;
    }
    &.type-3::before {
      background-position: -90px -269px;
    }
    .author,
    .meta {
      font-size: .8em;
      color: #666666;
    }
    .author {
      text-transform: uppercase;
    }
    .meta {
      font-style: italic;
    }
  }
}

.filters {
  .year,
  .author,
  .title {
    width: 30%;
  }
}

.form-text {
  height: 40px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Publications.vue